import script from "./MemoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./MemoryView.vue?vue&type=script&setup=true&lang=js"

import "./MemoryView.vue?vue&type=style&index=0&id=643df842&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-643df842"]])

export default __exports__